import React, { FunctionComponent, useState } from 'react';
import '@justgiving/modal/src/Modal.scss';
import { useTranslation } from 'react-i18next';

export const QRTips: FunctionComponent = () => {
  const [showQRCodeStats, setQRCodeStats] = useState(false);

  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <div className="col-sm-12 jg-space-ptml jg-space-phmd jg-space-mbmd">
      <div className="col-sm-12 jg-text--center jg-space-mbmd">
        <button
          className="jg-text--link jg-text--center"
          onClick={() => setQRCodeStats(!showQRCodeStats)}
        >
          {t('QRView.showTips')}
        </button>
      </div>

      {showQRCodeStats && (
        <>
          <p className="jg-space-mbmd" data-qa="qr-open-camera-tip">
            {t('QRView.openCameraTip')}
          </p>

          <h3 data-qa="qr-quick-tip">{t('QRView.quickTips')}</h3>

          <ol>
            <li className="jg-space-mbms">{t('QRView.tipOne')}</li>
            <li className="jg-space-mbms">{t('QRView.tipTwo')}</li>
            <li className="jg-space-mbms">{t('QRView.tipThree')}</li>
          </ol>
        </>
      )}
    </div>
  );
};

export default QRTips;
